require('./scss/Tooltip.scss');

export default {
    name: 'Tooltip',

    props: {
        text: { type: String, default: '' },
        click: { type: String, default: '' },
        placement: { type: String, default: 'top' },
    },

    data() {
        return {
            showTooltip: false,
        };
    },

    mounted() {
        this.registerClickEvent();

        this.setWidthForTooltips();
    },

    methods: {
        registerClickEvent() {
            if (this.click && window.bus) {
                window.bus.$on('tooltip.clicked', () => (this.showTooltip = false));
            }
        },

        setWidthForTooltips() {
            let textLength = this.$refs.tooltip.innerHTML.length;

            if (textLength < 50) {
                return (this.$refs.tooltip.style.width = textLength * 10 + 'px');
            }

            this.$refs.tooltip.style.width = textLength * 2 + 'px';
        },

        toggleTooltip() {
            if (this.click && window.bus) {
                let tooltipStatus = this.showTooltip;

                window.bus.$emit('tooltip.clicked');

                this.showTooltip = !tooltipStatus;
            }
        },
    },

    template: `
    <div class="gm-tooltip"
        :class="[showTooltip ? 'gm-tooltip:active' : '', 'gm-tooltip:' + placement]"
    >
        <div class="tooltip-text" ref="tooltip">{{ text }}</div> 
        <div @click="toggleTooltip" class="tooltip-element"><slot></slot></div>
    </div>
    `,
};
